import {useState, useEffect} from "react";
import moment from "moment";
import {useFetch} from "../../../../../hooks/useFetch";
import {useStore} from "../../../../../hooks/useStore";

export const useCourierWallet = ({courierLoading, courier, canRender}) => {
    const stores = useStore();
    const [wallet, setWallet] = useState(null);
    const [recallWallet, setRecallWallet] = useState(false);
    const [invoiceAccountStatus, setInvoiceAccountStatus] = useState(null);

    const [walletLoading] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.walletStore.getCourierWalletWithDailyTransactionsSummary.bind(null, {
            courierId: courier?._id,
            startDate: moment()
                .subtract(7, "day")
                ?.format("YYYY-MM-DD"),
            endDate: moment()?.format("YYYY-MM-DD")
        }),
        dependencies: [courier?._id, canRender, recallWallet],
        initialCall: Boolean(courier?._id) && canRender,
        condition: Boolean(courier?._id) && canRender && !courierLoading,
        callbackFunc: result => {
            setWallet(result?.data || null);
        },
        waitForResponse: true
    });

    useEffect(() => {
        async function fetchStatus() {
            if (!courier?._id) return;

            try {
                const data = await stores.walletStore.listWalletCouriers({courierId: courier._id});
                if (data?.rows && data.rows.length > 0) {
                    const status = data.rows[0]?.courierInvoiceAccount?.status || null;
                    setInvoiceAccountStatus(status);
                } else {
                    setInvoiceAccountStatus(null);
                }
            } catch (err) {
                console.error("Status fetch error:", err);
            }
        }

        fetchStatus();
    }, [courier?._id]);

    const refreshWallet = () => {
        setRecallWallet(!recallWallet);
    };

    return {
        wallet,
        walletLoading,
        refreshWallet,
        invoiceAccountStatus
    };
};
